import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';


@Component( {
	selector: 'folder-name-dialog',
	templateUrl: './folder-name-dialog.component.html',
} )
export class FolderNameDialog {


	folderNameCtrl = new FormControl( "" );


	constructor( public dialogRef: MatDialogRef<FolderNameDialog> ) {}


}
